import cn from 'classnames'

import {TTypographyProps} from './types'

import colorStyle from './styles/colors.module.css'
import fontStyle from './styles/kind.module.css'

export function tg({className, kind = 'body', mobile, color}: TTypographyProps) {
  return cn(
    fontStyle.root,
    fontStyle[kind],
    {
      [colorStyle[color]]: Boolean(color),
      [fontStyle[`${mobile?.kind}Mobile`]]: Boolean(mobile?.kind),
      [colorStyle[`${mobile?.color}Mobile`]]: Boolean(mobile?.color),
    },
    className,
  )
}
